import { BsGraphUp } from "react-icons/bs";
import {FaMoneyBillTrendUp} from "react-icons/fa6"
import {FaSignOutAlt} from "react-icons/fa"
import {BiMoneyWithdraw} from "react-icons/bi"
import {FaHistory} from "react-icons/fa"
import {CgProfile} from "react-icons/cg"
import {GiHamburgerMenu} from "react-icons/gi"
import {MdOutlineUnsubscribe} from "react-icons/md"
export const dashboard = <i className="fa-solid fa-chart-line"><BsGraphUp/></i>
export const transactions = <i className="fa-solid fa-credit-card"><FaMoneyBillTrendUp/></i>
export const signOut = <i className="fa-solid fa-chart-line"><FaSignOutAlt/></i>
export const Withdraw = <i className="fa-solid fa-chart-line"><BiMoneyWithdraw/></i>
export const history = <i className="fa-solid fa-chart-line"><FaHistory/></i>
export const profile = <i className="fa-solid fa-chart-line"><CgProfile/></i>
export const burger = <i className="fa-solid fa-chart-line"><GiHamburgerMenu/></i>
export const subscribe = <i className="fa-solid fa-chart-line"><MdOutlineUnsubscribe/></i>
